export const NoticePeriodList = [
  {
    value: '0-15',
    name: '0',
  },
  {
    value: '15-30',
    name: '15',
  },
  {
    value: '30-45',
    name: '30-45',
  },
  {
    value: '45-60',
    name: '45-60',
  },
  {
    value: '60-90',
    name: '60-90',
  },
  {
    value: '90+',
    name: '90+',
  },
]
export const checkboxLabels = [
  { label: 'Higher Education', value: 'HIGHEREDUCATION' },
  { label: 'Family Business', value: 'FAMILYBUSINESS' },
  { label: 'Entrepreneur', value: 'ENTREPRENEUR' },
  { label: 'Others', value: 'OTHERS' },
]

export const actionDrawerProps = {
  YesText: 'Submit',
  closeText: 'Back',
  showOptions: true,
  description: 'Select why you want to opt-out of placement process?',
  successModalMessage:
    'Successfully requested TPO approval.Await their confirmation to proceed with the placement process.',
  checkboxOptions: checkboxLabels,
}

export const showDrawerProps = {
  YesText: 'Proceed',
  closeText: 'Opt-out',
  description:
    'You can now proceed with the placement process, if you wish to opt-out for some reason,consider below option',
  successModalMessage:
    'You have successfully opted-in, if you wish to opt-out change in the settings.',
}

export const OPT_OUT_CONFIG = {
  OptedOutPending: {
    message:
      'You request to opt-out has been sent to the TPO for approval, no further action required.',
    actionText: 'Withdraw',
    variant: 'DangerStyle',
    borderColor: true,
    statusMessage:
      'You have successfully withdrawn, you can always change in the settings.',
    actionType: 'showSuccessModal',
  },
  OptedInPending: {
    message:
      'You request to opt-in has been sent to the TPO for approval, no further action required.',
    actionText: 'Withdraw',
    variant: 'DangerStyle',
    borderColor: true,
    statusMessage:
      'You have successfully withdrawn, you can always change in the settings.',
    actionType: 'showSuccessModal',
  },
  OptedOut: {
    message:
      'You are currently not in the placement process, do you wish to opt-in? The request will be sent to the TPO for approval.',
    actionText: 'Opt-in',
    variant: 'Primary',
    statusMessage:
      'You have successfully opted-in, if you wish to opt-out change in the settings.',
    actionType: 'optInProcess',
  },
  default: {
    message:
      'You are currently in the placement process. Do you wish to opt-out? The request will be sent to the TPO for approval.',
    actionText: 'Opt-out',
    variant: 'Secondary',
    actionType: 'openDrawer',
  },
}
